import axios from "axios";
import {APP_DISPLAY_ADS_API_ENDPOINT} from "../../../../../constants/api_urls";
import {getUserToken} from "../../../../../utils/functions/userToken";
import { extractErrorMessages } from "pages/displayAdsCampaignCreator/utils/createCampaignDisplayAds";

export const validateFinaleUrl = async (text) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_DISPLAY_ADS_API_ENDPOINT}/api/display-ads/campaign-validator/ads-creative/validate-one-final-url/`,
            { url: text },
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateDisplayAdsAdsCreative = async (adsCreative) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_DISPLAY_ADS_API_ENDPOINT}/api/display-ads/campaign-validator/ads-creative/validate-ads-creative/`,
            adsCreative,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );

        const { data } = response;
        const errors = extractErrorMessages(data)
        if (Object.keys(errors).length > 0) {
            return { success: false, errors };
        }

        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, errors: { global: "An unexpected error occurred during validation." } };
    }
};